<template>
  <div class="panel-centering" :class="{ panel: !hideBorder }">
    <div v-if="label" class="title">{{ label }}</div>
    <div
      class="button-container"
      v-for="(option, index) in options"
      :key="index"
    >
      <input
        :id="optionAsString(option)"
        type="radio"
        :name="optionAsString(option)"
        :value="optionAsValue(option)"
        @change="checkChange(option)"
        v-model="selectedValue"
      />
      <label
        :for="optionAsString(option)"
        :class="{
          active: optionAsValue(option) === selectedValue,
        }"
        >{{ optionAsString(option) }}</label
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "ProductOptionButtons",
  props: {
    options: Array,
    defaultVal: String,
    label: String,
    hideBorder: Boolean,
  },
  data() {
    return {
      selectedValue: this.defaultVal,
    };
  },
  updated() {
    this.$emit("options-updated");
  },
  methods: {
    checkChange(option) {
      this.$emit("button-value-changed", option);
    },
    optionAsValue(option) {
      if (typeof option === "object") return option.text;
      return option;
    },
    optionAsString(option) {
      if (typeof option === "object") return `${option.text} ${option.detail}`;
      return option;
    },
  },
};
</script>
<style scoped>
.panel-centering {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.panel {
  padding: 20px 30px 30px;
  border: 1px solid #dfdcd7;
  border-radius: 6px;
  margin-top: 15px;
}
.title {
  color: #000;
  font-size: 0.875em;
  letter-spacing: 0.25px;
  line-height: 20px;
  margin-bottom: 1em;
  opacity: 0.87;
  text-align: center;
}
input {
  display: none;
}
label {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  border: 1px solid #dfdcd7;
  border-radius: 6px;
  color: #3a3830;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 17px;
  opacity: 0.87;
  text-align: center;
  width: 100%;
  max-width: 180px;
  height: 39px;
  cursor: pointer;
}
label.active {
  background-color: #3a3830;
  color: #fff;
}
.button-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
  height: 40px;
}
</style>
